import api from '@/api/api';
import Product from '../models/Product';

const state = {
  ready_for_utilize_list: [],
  modal_ready_for_utilize: null,
  loaded: false,
};

const getters = {
  getSelectedProductsRFU: (state) => state.ready_for_utilize_list.filter((item) => item.length > 0)
    .map((items) => items.filter((item) => item.selected))
    .filter((item) => item.length > 0),
};

const mutations = {
  set_rfu_list: (state, payload) => {
    state.ready_for_utilize_list = payload;
  },

  set_selected: (state, payload) => {
    state.modal_ready_for_utilize = payload;
  },

  set_loaded: (state, payload) => {
    state.loaded = payload;
  },
};

const actions = {

  rfuset_selected: (context, payload) => {
    context.commit('set_selected', payload);
  },

  rfuset_loaded: (context, payload) => {
    context.commit('set_loaded', payload);
  },

  rfuload_list: (context) => {
    api().get(`${context.getters.get_app_section}/products/utilization_ready`)
      .then((resp) => resp.data)
      .then((data) => data.map((item) => {
        const products = item.map((subItem) => {
          const listItem = new Product(subItem);
          listItem.selected = false;
          listItem.isHidden = true;
          listItem.selected_quantity = subItem.quantity;
          listItem.valid = true;

          return listItem;
        });
        products.selectedPreview = false;
        products.isHidden = true;

        products.map((subItem) => {
          subItem.selected = false;
          return subItem;
        });

        return products;
      }))
      .then((list) => context.commit('set_rfu_list', list))
      .then(() => context.commit('set_loaded', true))
      .catch((error) => {
        console.error('Error:', error);
        context.commit('set_loaded', null);
      });
  },

  rfuutilize: (context, payload) => {
    api().put(`${context.getters.get_app_section}/products/utilize`,
      JSON.stringify({ items: payload }))
      .then((resp) => resp.data)
      .then((data) => (data !== 'OK' ? null : data))
      .then(() => {
        context.dispatch('rfuload_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Products were utilized.',
        });
      })
      .catch((error) => {
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Products weren\'t utilized. Please try again.',
        });
        console.error('Error:', error);
      });
  },

  rfuremove_products: (context, payload) => {
    api().put(`${context.getters.get_app_section}/products/return_to_instock`,
      JSON.stringify({ items: payload }))
      .then((resp) => resp.data)
      .then((data) => (data !== 'OK' ? null : data))
      .then(() => {
        context.dispatch('rfuload_list');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Products were deleted.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Products weren\'t deleted. Please try again.',
        });
      });
  },

};

export default {
  state,
  getters,
  mutations,
  actions,
};
